import api, { get, post } from '../utils/api';
import { CHAT_MESSAGE, CHAT_APPLY_PROFILE_UPDATE, CHAT_APPLY_PROFILE_ADD, CHAT_FEEDBACK, CHAT_MY_SESSION, CHAT_UPLOAD_RESUME, CHAT_START_REGISTRATION_FORM, CHAT_VERIFY_REGISTRATION_FORM_OTP, CHAT_LOGIN_FORM, CHAT_VERIFY_LOGIN_FORM_OTP } from '../config/api';

export const CHAT_SESSION_STORAGE_KEY = 'talexoChatSessionToken';

export const sendChatMessage = (message, sessionToken) => {
    return post(CHAT_MESSAGE, { message, sessionToken });
};

// Called only when the user clicks Confirm on a profile-update card —
// never triggered automatically by the chat itself.
export const confirmProfileUpdate = (field, value) => {
    return post(CHAT_APPLY_PROFILE_UPDATE, { field, value });
};

// Called only when the user clicks Confirm on a ProfileAddConfirmCard —
// never triggered automatically by the chat itself.
export const confirmProfileAdd = (section, record) => {
    return post(CHAT_APPLY_PROFILE_ADD, { section, record });
};

export const submitChatFeedback = (messageId, rating) => {
    return post(CHAT_FEEDBACK, { messageId, rating });
};

// Resolves the logged-in user's canonical conversation and overwrites the
// local pointer to it — call this right after ANY login (traditional or
// chat-based) so the same user always resumes the same conversation
// regardless of device/browser (plan Phase 5).
export const syncChatSession = async () => {
    try {
        const res = await get(CHAT_MY_SESSION);
        if (res?.responseData?.sessionToken) {
            localStorage.setItem(CHAT_SESSION_STORAGE_KEY, res.responseData.sessionToken);
        }
    } catch {
        // Non-critical — worst case the user keeps their pre-login anonymous
        // conversation id for this browser instead of their canonical one.
    }
};

// Plain-form registration — collects name/email/mobile in one screen instead
// of the LLM asking one field at a time in chat. Same underlying tool logic
// as the conversational flow (see chatbot.controller.js startRegistrationForm).
export const startRegistrationForm = (name, email, mobile, sessionToken, password) => {
    return post(CHAT_START_REGISTRATION_FORM, { name, email, mobile, sessionToken, password });
};

export const verifyRegistrationFormOtp = (otp, sessionToken) => {
    return post(CHAT_VERIFY_REGISTRATION_FORM_OTP, { otp, sessionToken });
};

// Plain-form login — email + password together on one screen, same in-chat
// screen model as registration but for an existing account.
export const loginForm = (email, password, sessionToken) => {
    return post(CHAT_LOGIN_FORM, { email, password, sessionToken });
};

export const verifyLoginFormOtp = (otp, sessionToken) => {
    return post(CHAT_VERIFY_LOGIN_FORM_OTP, { otp, sessionToken });
};

// Field name must be 'resume' — the backend reads req.files.resume, not the
// generic 'file' key the shared uploadFile() helper uses.
export const uploadResumeToChat = async (file, sessionToken) => {
    const formData = new FormData();
    formData.append('resume', file);
    formData.append('sessionToken', sessionToken || '');
    const response = await api.post(CHAT_UPLOAD_RESUME, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
};
